import React, { createContext, useEffect, useRef, useState } from "react";
import { HomeWrapper } from "../home/styled/HomeStyles";
import useLoadedUser from "../../hooks/auth/useLoadedUser";
import { UserRole } from "../../../models/User";
import { MyBookingWrapper, PaginationWrapper, PaginationWrapperTop } from "../MyBooking/styled/DesStyled";
import UserTable from "./component/UserTable";
import UserFilter from "./component/UserFilter";
import { getListUser } from "./hook/GetListUser";
import NumberPaginationBox from "../../controls/components/numberPaginationBox/NumberPaginationBox";
import useCommonListFunctions from "../../hooks/useCommonList/useCommonListFunctions";
import { PERPAGE } from "../Partner/PartnerManagement";

export const HomeContext = createContext<{
	openDetailDialog: boolean;

	loading: boolean;
	loadMore: () => void;
	isInitLoading: boolean;
	isValidated: boolean | undefined;
} | null>(null);

export default function UserManagementPage() {
	const hash = typeof window !== "undefined" && window ? window.location?.hash : undefined;
	useEffect(() => {
		if (hash === undefined) return;

		const timeout = setTimeout(() => {
			const distance = document.getElementById(hash.replace("#", ""))?.offsetTop || 0;
			window.scrollTo({
				top: distance,
				left: 0,
				behavior: "smooth",
			});
			clearTimeout(timeout);
		}, 300);
	}, [hash]);
	const { user } = useLoadedUser();
	const { listUser, reload, count } = getListUser({});
	const { page, doChangePage } = useCommonListFunctions();
	return (
		<MyBookingWrapper>
			<UserFilter reload={reload} />
<PaginationWrapperTop>
				<NumberPaginationBox
					page={page || 1}
					count={count}
					per={PERPAGE.PerPage}
					onChange={(val) => doChangePage?.(val)}
				/>
			</PaginationWrapperTop>
			<UserTable
				listUser={listUser}
				reload={reload}
			/>
			<PaginationWrapper>
				<NumberPaginationBox
					page={page || 1}
					count={count}
					per={PERPAGE.PerPage}
					onChange={(val) => doChangePage?.(val)}
				/>
			</PaginationWrapper>
		</MyBookingWrapper>
	);
}
